/** @jsx jsx */
import { jsx } from '@emotion/core';
import { CircularProgress, TextField, Tooltip } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { AutocompleteRenderInputParams } from '@material-ui/lab';
import React, { Fragment, ReactNode } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { CustomEndAdornment } from '../Input.styled';

interface IProps {
  parameters: AutocompleteRenderInputParams;
  meta: { error?: string; touched?: boolean };
  spinner?: boolean;
  error?: string;
  placeholder?: string;
}

type PropType = IProps & WithTranslation;

export class CustomSelectInput extends React.Component<PropType> {
  renderAdornment = (endAdornment: ReactNode): JSX.Element => {
    const { spinner, error, t } = this.props;

    if (spinner) {
      return (
        <CustomEndAdornment>
          <CircularProgress size={12} />
        </CustomEndAdornment>
      );
    }
    return (
      <Fragment>
        {error && (
          <Tooltip title={<Fragment>{t(error)}</Fragment>}>
            <ErrorIcon color="error" />
          </Tooltip>
        )}
        {endAdornment}
      </Fragment>
    );
  };

  render(): JSX.Element {
    const { parameters, meta, placeholder } = this.props;

    return (
      <TextField
        {...parameters}
        inputProps={{
          ...parameters.inputProps,
        }}
        variant="outlined"
        error={!!(meta.error && meta.touched)}
        placeholder={placeholder}
        InputProps={{
          ...parameters.InputProps,
          endAdornment: this.renderAdornment(parameters.InputProps.endAdornment),
        }}
      />
    );
  }
}

export default withTranslation()(CustomSelectInput);
